import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import walletApi from "./walletApi";

export const getSpotTransferHistoryForm = createThunkFromApi(
  "wallet/getSpotTransferHistoryForm",
  walletApi.getSpotTransferHistoryForm
);

export const getSpotWalletInfo = createThunkFromApi(
  "wallet/getSpotWalletInfo",
  walletApi.getSpotWalletInfo
);

export const getPortfolioChart = createThunkFromApi(
  "wallet/getPortfolioChart",
  walletApi.getPortfolioChart
);

export const getSpotWalletList = createThunkFromApi(
  "wallet/getSpotWalletList",
  walletApi.getSpotWalletList
);

export const getMarginWalletInfo = createThunkFromApi(
  "wallet/getMarginWalletInfo",
  walletApi.getMarginWalletInfo
);

export const getMarginWalletList = createThunkFromApi(
  "wallet/getMarginWalletList",
  walletApi.getMarginWalletList
);

export const getHistoryCryptoForm = createThunkFromApi(
  "wallet/getHistoryCryptoForm",
  walletApi.getHistoryCryptoForm
);

export const getHistoryFiatForm = createThunkFromApi(
  "wallet/getHistoryFiatForm",
  walletApi.getHistoryFiatForm
);

export const getHistoryFiatList = createThunkFromApi(
  "wallet/getHistoryFiatList",
  walletApi.getHistoryFiatList
);

export const getHistoryCryptoList = createThunkFromApi(
  "wallet/getHistoryCryptoList",
  walletApi.getHistoryCryptoList
);

export const getHistoryFiat = createThunkFromApi(
  "wallet/getHistoryFiat",
  walletApi.getHistoryFiat
);

export const getHistoryCrypto = createThunkFromApi(
  "wallet/getHistoryCrypto",
  walletApi.getHistoryCrypto
);

export const getSpotTransferHistoryList = createThunkFromApi(
  "wallet/getSpotTransferHistoryList",
  walletApi.getSpotTransferHistoryList
);

const initialState = {
  spotWalletInfo: null,
  portfolioChart: null,
  spotWalletList: null,
  marginWalletList: null,
  marginWalletInfo: null,
  historyForm: null,
  historyList: null,
  singleHistory: null,
  spotTransferHistoryForm: null,
  spotTransferHistoryList: null,
};

export const walletSlice = createSlice({
  name: "wallet",
  initialState,

  extraReducers: {
    [getSpotTransferHistoryForm.fulfilled]: (state, { payload }) => {
      state.spotTransferHistoryForm = payload.data;
    },

    [getMarginWalletInfo.fulfilled]: (state, { payload }) => {
      state.walletInitial = payload.data;
    },

    [getSpotWalletInfo.fulfilled]: (state, { payload }) => {
      state.spotWalletInfo = payload.data;
    },

    [getPortfolioChart.fulfilled]: (state, { payload }) => {
      state.portfolioChart = payload.data;
    },

    [getSpotWalletList.fulfilled]: (state, { payload }) => {
      state.spotWalletList = payload.data;
    },

    [getMarginWalletList.fulfilled]: (state, { payload }) => {
      state.marginWalletList = payload.data;
    },

    [getHistoryCryptoForm.fulfilled]: (state, { payload }) => {
      state.historyForm = payload.data;
    },

    [getHistoryFiatForm.fulfilled]: (state, { payload }) => {
      state.historyForm = payload.data;
    },

    [getHistoryFiatList.fulfilled]: (state, { payload }) => {
      state.historyList = payload.data;
    },

    [getHistoryCryptoList.fulfilled]: (state, { payload }) => {
      state.historyList = payload.data;
    },

    [getHistoryCrypto.fulfilled]: (state, { payload }) => {
      state.singleHistory = payload.data;
    },

    [getHistoryFiat.fulfilled]: (state, { payload }) => {
      state.singleHistory = payload.data;
    },

    [getSpotTransferHistoryList.fulfilled]: (state, { payload }) => {
      state.spotTransferHistoryList = payload;
    },
  },
});

export default walletSlice.reducer;
